<template>
  <div class="question" @click="questionClick" :style="{ width: videoWH.w + 'px', height: videoWH.h + 'px' }">
    <kejian
      :subType="data.sub_type"
      :type="data.type"
      :iframeQuickId="data.id"
      :gameName="data.folder"
      :topicType="type"
      :questionInfo="data"
      :iframeRight="questionRight"
      @answerQuestion="answerQuestion"
      @loadErr="loadErr"
      @loadSuccess="loadSuccess"
      @showToast="showToast"
      ref="kejian"
      :style="{'pointer-events': pointer || type===4?'none':'auto'}"
    />
  </div>
</template>
<script>
import utils from "utils"
import kejian from "../video/answer/kejian.vue";
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  name:"question",
  data() {
    return {
      videoWH:utils.setVideoWH(74),
      pointer:0,
      oldId:0,
    };
  },
  computed: {
    ...mapState(["lesson_id", "class_id", "userID", "course_id"]),
    data(){
      let data = this.progressArr[this.currentIndex-1] || {};
      // console.log(data)
      this.$parent.loadingShow = this.oldId !== data.id && data.id?true:false;
      this.oldId = data.id;
      this.pointer=0;
      if(this.type===5 && data.status==2){//订正
        this.pointer=3;
      }else if(this.type===3){//做题
        if(data.type==4){//学具题
          if(data.status==1){//作对
            this.pointer=1;
          }else if(data.status==0 && data.count>=3){//做错且无作答机会
            this.pointer=2;
          }
        }
      }
      return data;
    },
  },
  components: {
    kejian,
  },
  props:{
    progressArr:{
      type:Array,
      default:()=>{
        return []
      }
    },
    currentIndex:{
      type:Number
    },
    type:{
      type:Number,
      required:true
    },
    questionRight:{
      type:Number,
      required:true
    }
  },
  created() {
    window.onresize = () => {
      this.videoWH = utils.setVideoWH(74);
    };
  },
  methods: {
    ...mapActions([
      "exerciseQuestionSave",
      "exerciseCorrect"
    ]),
    loadSuccess(){
      this.$parent.loadingShow = false;
    },
    questionClick(){
      this.$emit("showToast",{type:this.pointer})
    },
    showToast(type){
       this.$emit("showToast",{type:type})
    },
    //加载失败
    loadErr(){
      this.$parent.loadingShow = false;
      this.$emit('questionLoadErr')
    },
    //答题
    answerQuestion(datas){
      // console.log(datas)
      if(this.type===5){
        this.correct(datas);
        return
      }
      this.questionSave(datas);
    },
    questionSave(datas) {
      //保存每题答题信息
      this.exerciseQuestionSave({
        answer: datas.answer,
        answerStatus: datas.answerStatus,
        courseId:this.course_id,
        lessonId: this.lesson_id,
        questionId: this.data.id,
        questionIndex: this.data.index,
        status: datas.status,
        studentId: this.userID,
        type: this.data.type,
      }).then(({ res, ok }) => {
        if(ok){
          this.$emit('saveQuestionSuccess',datas);
        }else{
          this.$refs.kejian.RightAudioUrl = "";
          this.$refs.kejian.WrongAudioUrl = "";
          if(res.code==='EXE111'){
            datas.status = 0;
            datas.count=3;
            this.$emit("showToast",{type:0,text:res.message});
            setTimeout(()=>{
              this.$emit('saveQuestionSuccess',datas);
            },3000)
          }else if(res.code==='EXE112'){
            datas.status = 1;
            datas.rightAnimation = "";
            datas.rightAnimation = "";
            this.$emit("showToast",{type:0,text:res.message});
            setTimeout(()=>{
              this.$emit('saveQuestionSuccess',datas);
            },3000)
          }
        }
      });
    },
    //订正
    correct(datas) {
      const correctNumArr = this.progressArr.filter((v)=>{
        return v.status==0;
      })
      //订正
      this.exerciseCorrect({
        answer:datas.answer,
        answerStatus:  datas.answerStatus,
        correctNum: correctNumArr.length-1,
        lessonId: this.lesson_id,
        questionId: this.data.id,
        questionIndex: this.data.index,
        status: datas.status,
        studentId: this.userID,
        classId:this.class_id
      }).then(({ res, ok }) => {
         if(ok){
           this.$emit('correctQuestionSuccess',datas);
         }else{
           if(res.code==='EXE111'){
            datas.status = 1;
            datas.rightAnimation = ""
            datas.rightAnimation = ""
            this.$refs.kejian.RightAudioUrl = ""
            this.$refs.kejian.WrongAudioUrl = ""
            this.$emit("showToast",{type:0,text:res.message});
            setTimeout(()=>{
              this.$emit('correctQuestionSuccess',datas);
            },3000)
           }
         }
      });
    },
  },
  beforeDestroy() {
    window.onresize = null;
  },
};
</script>
<style lang="less" scoped rel="stylesheet/less">
.question {
  position: relative;
  z-index: 30;
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/homework/question.vue